import { render, staticRenderFns } from "./TId.vue?vue&type=template&id=156ac4de"
import script from "./TId.vue?vue&type=script&lang=js"
export * from "./TId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports